import MobileVerticalEventCard from "./MobileVerticalEventCard";

export default function MobileEventList({events, setListView}) {
    return (
        <div className="container">
            <div className="row justify-content-around">
                        <div className="col">
                            <a href="/" aria-labelledby="Back button" role="button" type="button" className="btn">
                                <i className="fa fa-arrow-left" aria-hidden="true"></i>
                            </a>
                        </div>
                        <div className="col-2">
                            <button type="button" className="btn btn-outline-dark px-1 py-1" onClick={() => setListView(false)}>Map</button>
                        </div>
            </div>
            {events.map(event => (
                <MobileVerticalEventCard key={event.id} event={event}/>
            ))}
          </div>
    )

}